const EnvelopePartiesModule = {
  namespaced: true,
  getters: {
    list: (state, getters, rootState) => {
      const { documents } = rootState.envelopes.creating.envelope;

      return documents.reduce((parties, doc) => {
        if (parties.length < doc.parties.length) {
          return doc.parties;
        }
        return parties;
      }, []);
    },
  },
};

export default EnvelopePartiesModule;
